"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormAlert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const react_hook_form_1 = require("react-hook-form");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const FormAlert = (props) => {
    const { condition, message, severity = "warning", ...rest } = props;
    const values = (0, react_hook_form_1.useWatch)();
    if (!condition(values)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(ui_kit_1.Alert, { severity: severity, ...rest, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: message }) }));
};
exports.FormAlert = FormAlert;
//# sourceMappingURL=index.js.map